import { Form, Modal, Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import _ from 'lodash';
import React, { ReactElement, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import ICondition from '~Api/Application/ICondition';
import WorkflowStatusEnum from '~Api/Application/WorkflowStatusEnum';
import { applicationConditionRequiredWorkflowStatusAction } from '~Applications/actions';
import { workflowStatusLabels } from '~Applications/workflowStatusLabels';

export default function RequiredBeforeModal(props: {
    condition?: ICondition;
    isOpen: boolean;
    onCancel: () => void;
}): ReactElement {
    const {
        condition,
        isOpen,
        onCancel,
    } = props;
    const [ requiredWorkflowStatus, setRequiredWorkflowStatus ] = useState<WorkflowStatusEnum>(null);
    const dispatch: Dispatch = useDispatch();

    const onOk: () => void = useCallback(() => {
        dispatch(applicationConditionRequiredWorkflowStatusAction(
            condition.uuid,
            requiredWorkflowStatus,
        ));
        onCancel();
    }, [
        condition,
        dispatch,
        onCancel,
        requiredWorkflowStatus,
    ]);

    const onSelectWorkflowStatus: (requiredWorkflowStatus: WorkflowStatusEnum) => void = useCallback((requiredWorkflowStatus: WorkflowStatusEnum) => {
        setRequiredWorkflowStatus(requiredWorkflowStatus);
    }, []);

    const workflowStatusOptions: DefaultOptionType[] = _.map(workflowStatusLabels, (label: string, workflowStatus: string) => ({
        label,
        value: workflowStatus,
    }));

    const workflowStatusSelectValue: WorkflowStatusEnum = (
        requiredWorkflowStatus || (
            condition.requiredWorkflowStatuses.length > 0
            ? condition.requiredWorkflowStatuses[0]
            : null
        )
    );

    return (
        <Modal
            destroyOnClose={true}
            onCancel={onCancel}
            open={isOpen}
            onOk={onOk}
            okText='Save'
            title={condition.name}
            wrapClassName='application-conditions-required-before-modal'
        >
            <Form.Item
                label='Required Before'
                className='workflow-status'
            >
                <Select
                    onChange={onSelectWorkflowStatus}
                    value={workflowStatusSelectValue}
                    options={workflowStatusOptions}
                />
            </Form.Item>
        </Modal>
    );
}